import React, { useState, useEffect } from "react";
import { FaFacebook, FaGoogle, FaTimes } from "react-icons/fa"; 
import { TiVendorMicrosoft } from "react-icons/ti";// Close Icon
import { CgMail } from "react-icons/cg";
import rightsidepopupimage from "../../../assets/signuprightside.jpg";
import CustomPopup from "./CustomSignup";
import CustomeSignInPopup from "./CustomeSignInPopup";
import {app} from "../../../firebase"
import { GoogleAuthProvider, signInWithPopup, getAuth, FacebookAuthProvider, onAuthStateChanged } from "firebase/auth";
import api from "../../../utils/api";
import Cookies from 'js-cookie';
import { LoadUserSuccess } from "../../../redux/userSlice";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { showCustomAlert } from "./Toast";
const Popup = () => {
  const dispatch = useDispatch();
const navigate=useNavigate()
  // State to handle popup visibility and type
  const [popupType, setPopupType] = useState("signup"); // "signup" or "login"
  const [showCustomPopup, setShowCustomPopup] = useState(false); // Visibility for CustomPopup
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      id: 1,
      title:
        "Delight your senses with exquisite flavors in a warm, welcoming ambiance.",
      image: rightsidepopupimage,
    },
    {
      id: 2,
      title:
        "Log in to explore our menu and enjoy exclusive offers. Great food await you.",
      image: rightsidepopupimage,
    },
    {
      id: 3,
      title:
        "Sign in for exclusive deals and quick orders. Your favorite flavors, just a click away.",
      image: rightsidepopupimage,
    },
  ];

  // Function to change the slide
  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  // Auto slide effect
  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length); // Loop through slides
    }, 5000);

    return () => clearInterval(intervalId);
  }, []);

  // Function to close the popup
  const closePopup = () => {
    setPopupType(null); // Close any open popup
  };

  // Function to handle email signup
  const handleEmailSignUp = () => {
    setPopupType(null); // Close the current popup
    setShowCustomPopup(true); // Show CustomPopup
  };

  // Function to close the custom popup
  const closeCustomPopup = () => {
    setShowCustomPopup(false);
  };
  const auth = getAuth(app);
  const handleGoogleClick = async () => {
    console.log("You clicked me");
    const provider = new GoogleAuthProvider();
    provider.setCustomParameters({ prompt: "select_account" });
  
    try {
      console.log("Starting sign-in...");
      const resultFromGoogle = await signInWithPopup(auth, provider);
      console.log("Sign-in result: ", resultFromGoogle);
      const googleUser = resultFromGoogle.user;
      const idToken = await resultFromGoogle.user.getIdToken();
      console.log("ID Token:", idToken);
  
      const mappedData = {
        name: googleUser.displayName || "No Name Provided", // Map displayName to name
        contact: googleUser.phoneNumber || "No Contact Provided", // Map phoneNumber to contact
        email: googleUser.email,
        idToken: idToken, // Include ID token for authentication
      };
      // Send the ID token to your backend API
      const res = await api.post("/auth/firebase-login",mappedData);
      console.log("🚀 ~ handleGoogleClick ~ res:", res);
  
      if (res.data && res.data.tokens) {
        console.log("🚀 ~ Google Login Success ~ data:", res);
        localStorage.setItem("userId", res.data.user._id); // Save user ID
        localStorage.setItem("email", res.data.user.email); // Save user ID
        localStorage.setItem("contact", res.data.user.contact); // Save user ID
        localStorage.setItem("name", res.data.user.name); // Save user ID

        // Save tokens in cookies or localStorage
        Cookies.set("accessToken", res.data.tokens.access.token, {
          expires: new Date(res.data.tokens.access.expires),
        });
        // localStorage.setItem("userId", res.data.user._id); // Save user ID
        Cookies.set("refreshToken", res.data.tokens.refresh.token, {
          expires: new Date(res.data.tokens.refresh.expires),
        });
  
        // Dispatch user data to Redux or any state management
        dispatch(LoadUserSuccess(res.data.user));
  
        // Show success message
      if(res?.data?.reward){
        showCustomAlert({
            title: 'Congratulations!',
            html: '<p style="color: #555;">You have successfully Signed up  and earned a reward!</p>',
            timer: 4000,
            icon: 'success',
            confirmButtonText: 'Claim Reward',
            confirmButtonColor: '#af313d',
            background: '#ffffff',
          });
      }else  {
        showCustomAlert({
          title: "Welcome Back!",
          html: "<p style='color: #555;'>You have successfully logged in.</p>",
          icon: "success",
          confirmButtonText: "Continue",
          confirmButtonColor: "#af313d",
          background: "#ffffff",
        });
        // const response = await api.patch('/manualFund/claimPoints')
       }

             Cookies.get("selectedSlug") ? navigate(`/${Cookies.get("selectedSlug")}`) : navigate("/");
              setTimeout(() => {
                window.location.reload()
              }, 1000);
        // navigate("/");  // Navigate to the home page
      } else {
        // toast.error(res.message || "Google login failed. Please try again.");
      }
    } catch (error) {
      console.error("Error during Google login:", error);
      // toast.error("An error occurred during Google login. Please try again.");
    }
  };
const handleFacebookClick = async () => {
  console.log("Facebook login clicked");
  
  // Initialize the Facebook provider
  const provider = new FacebookAuthProvider();
  provider.setCustomParameters({ prompt: "select_account" });

  try {
    // Sign in with Facebook and get the result
    const resultFromFacebook = await signInWithPopup(auth, provider);
    console.log(resultFromFacebook);

    // Get the Firebase ID token
    const idToken = await resultFromFacebook.user.getIdToken();
    console.log("🚀 ~ handleFacebookClick ~ idToken:", idToken);

    // Send the ID token to your backend API
    const res = await api.post("/auth/firebase-login", { idToken });
    console.log("🚀 ~ handleFacebookClick ~ res:", res);

    if (res.data && res.data.tokens) {
      console.log("🚀 ~ Facebook Login Success ~ data:", res);

      // Save user data and tokens
      localStorage.setItem("userId", res.data.user._id);
      localStorage.setItem("email", res.data.user.email);

      Cookies.set("accessToken", res.data.tokens.access.token, {
        expires: new Date(res.data.tokens.access.expires),
      });
      Cookies.set("refreshToken", res.data.tokens.refresh.token, {
        expires: new Date(res.data.tokens.refresh.expires),
      });

      // Dispatch user data to Redux or any state management
      dispatch(LoadUserSuccess(res.data.user));

      // Show success message
      toast.success("Login Successful!", {
        style: { backgroundColor: "white", color: "#AD343E" },
        icon: <span style={{ color: "#AD343E" }}>✔</span>,
      });

      // Navigate to the home page
      Cookies.get("selectedSlug") ? navigate(`/${Cookies.get("selectedSlug")}`) : navigate("/");
      setTimeout(() => {
        window.location.reload()
      }, 1000);
    } else {
      toast.error("Facebook login failed. Please try again.");
    }
  } catch (error) {
    console.error("Error during Facebook login:", error);

    if (error.code === 'auth/popup-closed-by-user') {
      toast.error("The popup was closed before login could complete. Please try again.");
    } else {
      toast.error("An error occurred during Facebook login. Please try again.");
    }
  }
};

  useEffect(() => {
  const unsubscribe = onAuthStateChanged(auth, (user) => {
    if (user) {
      console.log("User is logged in:", user);
      // Handle the successful login logic here
    } else {
      console.log("No user is logged in.");
    }
  });

  return () => unsubscribe();
}, []);

  return (
    <div>
      {/* Render Sign-Up Popup */}
      {popupType === "signup" && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 flex justify-center items-center z-50">
          <div className="lg:w-[70%] lg:h-[90%] md:w-[94%] md:h-[80%] w-[90%] h-[70%] sm:w-[90%] sm:h-[70%] bg-white rounded-lg relative overflow-hidden">
            {/* Close Button */}
            <button
              onClick={closePopup}
              className="absolute top-2 right-2 z-50 bg-gray-200 hover:bg-gray-300 p-2 rounded-full text-xl text-gray-500"
            >
              <FaTimes />
            </button>

            {/* Popup Content */}
            <div className="flex md:flex-row sm:flex-col flex-col w-full h-full">
              {/* Left Section: Image Slider */}
              <div className="md:w-[50%] sm:h-[50%] h-[50%] md:h-full">
                <div className="relative w-full h-full overflow-hidden">
                  <div
                    className="w-full h-[100%] flex transition-transform duration-700"
                    style={{ transform: `translateX(-${currentSlide * 100}%)` }}
                  >
                    {slides.map((slide) => (
                      <div key={slide.id} className="w-full flex-shrink-0">
                        <div
                          className="relative w-full h-full bg-[#AF313D] "
                         
                        >
                          <div className="absolute inset-0 flex flex-col items-center justify-center text-center text-white p-4">
                            <h3 className="text-xl font-bold">{slide.title}</h3>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex items-center space-x-2">
                    {slides.map((_, index) => (
                      <div
                        key={index}
                        className={`cursor-pointer ${
                          index === currentSlide
                            ? "w-16 h-2 bg-[#AF313D] rounded-full"
                            : "w-3 h-3 bg-[#737373] rounded-full"
                        }`}
                        onClick={() => goToSlide(index)}
                      ></div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Right Section: Sign-Up Form */}
              <div className="md:w-[50%] w-[90%] sm:w-[90%] md:p-6 sm:p-2 p-2 flex flex-col justify-center">
                <h2 className="lg:text-[36px]  body text-[25.2px] sm:text-[25.2px] md:text-[25px]  font-semibold text-center mb-4">
                   Join Our Table
!
                </h2>

                <div className="space-y-4" >
                  <Link
                   to={`https://cashback-479780104538.europe-west2.run.app/auth/outlook`}
                  className="lg:w-[300px] md:w-[235.49px] md:h-[37.72px] sm:w-[194.78px] sm:h-[30.96px] w-[194.78px] h-[30.96px] mx-auto flex gap-3 items-center md:text-[13.57px] justify-center py-2 bg-[#111827] text-white rounded-full lg:h-[56px] md:text-lg sm:text-[11.23px] text-[11.23px]">
                    <TiVendorMicrosoft className=" text-2xl" />
                    <h1>Sign up with Outlook</h1>
                  </Link>
                  <button 
  onClick={() => {
    if (closePopup) closePopup(); // Close the popup
    handleGoogleClick();          // Handle Google login
  }} 
  className="lg:w-[250px] w-[155px] sm:w-[155px] md:h-[37.72px] md:w-[200.06px] h-[25px] sm:h-[25px] mx-auto flex gap-3 items-center bg-[#AFAFAF] sm:text-[11.23px] md:text-[13.57px] text-[11.23px] justify-center py-2 text-white rounded-full lg:h-[56px] md:text-lg"
>
  Sign in with Google
</button>
                </div>
                <div className="mt-3">
                  <h1 className="items-center justify-center flex text-center text-[10px]">
                    OR
                  </h1>
                  <button
                    onClick={handleEmailSignUp} // Trigger email signup
                    className="lg:w-[300px] md:text-[13.57px] md:w-[235.49px] md:h-[37.72px] sm:w-[194.78px] sm:h-[30.96px] w-[194.78px] h-[30.96px] md:mt-4 mt-2 sm:mt-2 mx-auto flex gap-3 bg-[#AF313D] sm:text-[11.23px] text-[11.23px] items-center justify-center py-2  text-white rounded-full lg:h-[56px] lg:text-lg"
                  >
                    <CgMail />
                    <h1>Sign up with Email</h1>
                  </button>
                </div>
                <div className="flex justify-center items-center text-center gap-2 mt-3">
                  <h1 className="text-[#9CA3AF] lg:text-[14px] text-[10.15px]">
                    Already have an account?
                  </h1>
                  <button
                    onClick={() => setPopupType("login")} // Show login popup
                    className="lg:text-[14px] underline text-[10.15px]"
                  >
                    Log in
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Render Login Popup */}
      {popupType === "login" && (
        <CustomeSignInPopup closePopup={() => setPopupType(null)} />
      )}

      {/* Render Custom Popup */}
      {showCustomPopup && <CustomPopup closePopup={closeCustomPopup} />}
    </div>
  );
};

export default Popup;
